import React from 'react';
import { ArrowRight as ArrowRightIcon, ArrowsClockwise as ArrowsClockwiseIcon } from '@phosphor-icons/react';
import { Section, SectionTitle, Lead } from '../Section';
import { flowSteps } from '../../data/proposal';
export function IdeaSection() {
  return <Section id="idea" index="03" label="The idea" data-id="element-123" data-mp="2gnm1xh2bkuy2">
      <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-124" data-mp="2lldpjyvxluwg">
        <div data-id="element-125" data-mp="2pmh84t5d651d">
          <SectionTitle data-id="element-126" data-mp="2pmpk8itnx6bi">
            Make every clinician
            <br data-id="element-127" data-mp="2pk3bwgyy6ms8" />a campaign.
          </SectionTitle>
          <Lead className="mt-5" data-id="element-128" data-mp="2ujps8za2oj59">
            For each clinician and clinical case, Snakker creates a short standalone Teaser built
            around the most interesting question, challenge, decision or outcome in that case.
          </Lead>
          <p className="mt-4 font-heading text-xl leading-snug text-primary" data-id="element-129" data-mp="34cofodtu23na">
            The Teaser doesn’t give away the full story. It creates the curiosity to see it.
          </p>
        </div>

        <div data-id="element-130" data-mp="3d95r7i6403jk">
          <ol className="space-y-2" data-id="element-131" data-mp="2jabpilvgxbse">
            {flowSteps.map((step, i) => <li key={step} className="flex items-center gap-4 rounded-lg border border-white/10 bg-white/[0.03] px-4 py-3" data-id="element-132" data-mp="2j88qjccc88bj" data-mpi={i}>
                <span className="font-body text-xs tracking-[0.2em] text-primary" data-id="element-133" data-mp="29cnt7ri7rw84">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="font-heading text-lg text-white" data-id="element-134" data-mp="321mg11xa7mjr">{step}</span>
              </li>)}
          </ol>

          <div className="mt-6 rounded-xl border border-secondary/25 bg-secondary/[0.06] p-5" data-id="element-135" data-mp="2x3b14cs4qluo">
            <p className="flex items-center gap-2 font-body text-[11px] uppercase tracking-[0.2em] text-secondary" data-id="element-136" data-mp="2s9yqx7o76hlg">
              <ArrowsClockwiseIcon size={13} weight="bold" aria-hidden="true" data-id="element-137" data-mp="2nbwwxrp8gxv7" />
              Self-reinforcing loop
            </p>
            <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1.5 font-heading text-base text-white" data-id="element-138" data-mp="3g0uefslmeqmw">
              <span data-id="element-139" data-mp="1e3k498y07uv4">Individual case</span>
              <ArrowRightIcon size={13} className="text-primary" aria-hidden="true" data-id="element-140" data-mp="1e3u03d5qcw8q" />
              <span data-id="element-141" data-mp="1j1df4fa95d1q">Full Filtek clinical case campaign</span>
              <ArrowRightIcon size={13} className="text-primary" aria-hidden="true" data-id="element-142" data-mp="14dsa2ftth3r6" />
              <span data-id="element-143" data-mp="14bo5rws0a2qd">Discover additional cases</span>
            </div>
            <p className="mt-3 font-body text-sm text-white/60" data-id="element-144" data-mp="19b0rge7553rd">
              Each case promotes itself — and the wider campaign.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}